export const NODE_ENV = process.env.NODE_ENV;
export const APP_ENV = process.env.REACT_APP_ENV;
export const APP_VERSION = process.env.REACT_APP_VERSION;

export const API_URL_BACKEND = process.env.REACT_APP_API_URL_BACKEND;

export const GA_ID = process.env.REACT_APP_GA;

export const ROUTE_BASENAME = process.env.REACT_APP_ROUTE_BASENAME

export const ENABLE_BETA = process.env.REACT_APP_ENABLE_BETA
export const ROUTE_BASENAME_BETA = process.env.REACT_APP_ROUTE_BASENAME_BETA

export const RECAPTCHA_KEY = process.env.REACT_APP_RECAPTCHA_KEY

export const AWS = {
  aws_project_region: process.env.REACT_APP_AWS_PROJECT_REGION,
  aws_cognito_identity_pool_id: process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID,
  aws_cognito_region: process.env.REACT_APP_AWS_COGNITO_REGION,
  aws_user_pools_id: process.env.REACT_APP_AWS_USER_POOLS_ID,
  aws_user_pools_web_client_id: process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID,
  aws_appsync_graphqlEndpoint: process.env.REACT_APP_AWS_APPSYNC_GRAPHQL_ENDPOINT,
  aws_appsync_region: process.env.REACT_APP_AWS_APPSYNC_REGION,
  aws_appsync_authenticationType: process.env.REACT_APP_AWS_APPSYNC_AUTHENTICATION_TYPE,
  aws_appsync_apiKey: process.env.REACT_APP_AWS_APPSYNC_API_KEY,
};
